export const lineData = [
    {
        line1: "Hey there, miss, are you a star?",
        cd: "Why?",
        line2: "Because you light up my world from afar.",
    },
    {
        line1: "Are you a thief?",
        cd: "Why?",
        line2: "Cause you stole my heart.",
    },
    {
        line1: "Is your name Google?",
        cd: "No, Why?",
        line2: "Because you’ve got everything I’ve been searching for.",
    },
    {
        line1: "Excuse me, do you have a map?",
        cd: "Why?",
        line2: "Because I keep getting lost in your eyes, it’s a trap.",
    },
    {
        line1: "Are you French",
        cd: "No, Why?",
        line2: "because Eiffel for you.",
    },
    {
        line1: "If nothing lasts forever,",
        cd: "So",
        line2: "will you be my nothing?",
    },
    {
        line1: "Kiss me if I’m wrong",
        cd: "Ok",
        line2: "dinosaurs still exist, right?",
    },
    {
        line1: "I’m not feeling myself today.",
        cd: "Ahh, Why?",
        line2: "Can I feel you instead?",
    },
    {
        line1: "There must be something wrong with my eyes",
        cd: "Why? what happened",
        line2: "I can’t take them off you.",
    },
    {
        line1: "I should charge you rent.",
        cd: "Why?",
        line2: "You spend so much time in my mind",
    },
    {
        line1: "My lips are like skittles.",
        cd: "So?",
        line2: "Wanna taste the rainbow?",
    },
    {
        line1: "People call me Bibhu",
        cd: "So?",
        line2: "but you can call me tonight.",
    },
    {
        line1: "Hey! Are you garbage?",
        cd: "Ewww! Why?",
        line2: "I’ll take you out!",
    },
    {
        line1: "I’m so lost.",
        cd: "Awww, Why?",
        line2: "I was looking for your number. ",
    },
    {
        line1: "Do you want to see a picture of a beautiful person?",
        cd: "Yaaa!",
        line2: "(hold up a mirror)",
    },
    {
        line1: "Are you from McDonald’s? ",
        cd: "Haha, Why?",
        line2: "Cause I’m lovin’ it! ",
    },
    {
        line1: "Did you swallow magnets?",
        cd: "Hahaha, Nope.",
        line2: "Cause you’re attractive",
    },
    {
        line1: "Do you have a name?",
        cd: "Yes, Why?",
        line2: "or can I call you mine?",
    },
    {
        line1: "Would you grab my arm",
        cd: "But! why?",
        line2: "so I can tell my friends I’ve been touched by an angel?",
    },
    {
        line1: "Do you know what rhymes with cucumber?",
        cd: "Nah, what?",
        line2: "Your number.",
    },
    {
        line1: "Can you pinch me!",
        cd: "Why?",
        line2: "because you’re so fine I must be dreaming.",
    },
    {
        line1: "Are you an omelette?",
        cd: "Hahaha! Why?",
        line2: "Because you’re making me egg-cited!",
    },
    {
        line1: "Are you a magician?",
        cd: "Haha, No! Why?",
        line2: "When I look at you everything disappears.",
    },
    {
        line1: "Hug me if I’m wrong",
        cd: "Ok",
        line2: "the earth is flat!",
    },
    {
        line1: "Are you a keyboard?",
        cd: "Haha! Why?",
        line2: "Because you are my type.",
    },
    {
        line1: "There is something wrong with my phone.",
        cd: "Ahhhh!",
        line2: "Could you call it for me to see if it rings?",
    },
    {
        line1: "Do you have an inhaler?",
        cd: "Why?",
        line2: "Because you took my breath away!",
    },
    {
        line1: "You hand looks pretty heavy.",
        cd: "Ahh! seriously!",
        line2: "Can I hold it for you?",
    },
    {
        line1: "You must be a ninja,",
        cd: "How?",
        line2: "because you snuck into my heart.",
    },
    {
        line1: "I’m not drunk",
        cd: "Then?",
        line2: "I’m just intoxicated by you",
    },
    {
        line1: "What time are you moving back?",
        cd: "Where?",
        line2: "you have to back to heaven, right?",
    },
    {
        line1: "If a fat man puts you in a bag at night",
        cd: "Ewww!",
        line2: "don't worry I told Santa I wanted you for Christmas",
    }
]